import { render, staticRenderFns } from "./resultList.vue?vue&type=template&id=24405b00&scoped=true"
import script from "./resultList.vue?vue&type=script&lang=js"
export * from "./resultList.vue?vue&type=script&lang=js"
import style0 from "./resultList.vue?vue&type=style&index=0&id=24405b00&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24405b00",
  null
  
)

export default component.exports